<template>
    <div>

        <div class="d-block d-lg-none">
            <div v-for="(item, index) in items" :key="'order-item-list-'+index">

                <!-- <b-form-group label-cols="12" label="Section" class="mb-2">
                    <b-select required :options="sections" v-model="item.section"></b-select>
                </b-form-group> -->

                <b-row class="product-selection">
                    <b-col cols="12"><div class="pb-1">Product</div></b-col>
                    <b-col v-if="item.type.name === 'Blocks'">
                        <div v-if="item.type.product_categories">
                            <b-select v-model="item.product_id" required>
                                <b-select-option value="">-- Choose --</b-select-option>
                                <b-select-option-group 
                                    v-for="(category) in item.type.product_categories" 
                                    :label="category.name"
                                    :key="'block-product-category-'+category.id"
                                >
                                    <b-select-option
                                            v-for="(product) in category.products"
                                            :key="'block-product-'+product.id"
                                            :value="product.id"
                                    >{{decodeHTMLEntities(product.name)}}</b-select-option>
                                </b-select-option-group>
                            </b-select>
                        </div>
                    </b-col>
                    <b-col v-if="item.type.name === 'Insulation'">
                        <div v-if="item.type.product_classifications" class="clearfix">
                            <b-select v-model="item.product_id" class="w-100 float-left" required>
                                <b-select-option value="">-- Choose --</b-select-option>
                                <b-select-option-group 
                                    v-for="(classification) in item.type.product_classifications" 
                                    :label="classification.name"
                                    :key="'insulation-classification-'+classification.id"
                                >
                                    <b-select-option
                                        v-for="(product) in classification.products"
                                        :value="product.id"
                                        :key="'insulation-product-'+product.id"
                                    >{{decodeHTMLEntities(product.name)}}</b-select-option>
                                </b-select-option-group>
                            </b-select>
                            <b-input-group class="w-100 float-left">
                                <b-form-input type="number" step="0.01" v-model="item.insulation_cut.thickness" placeholder="Thickness" required></b-form-input>
                                <b-form-select v-model="item.insulation_cut.thickness_unit" :selected="'in'" :options="['in']" required></b-form-select>
                            </b-input-group>
                            <b-input-group class="w-100 float-left">
                                <b-form-input type="number" step="0.01" v-model="item.insulation_cut.width" placeholder="Width" required></b-form-input>
                                <b-form-select v-model="item.insulation_cut.width_unit" :selected="'ft'" :options="['ft','in']" required></b-form-select>
                            </b-input-group>
                            <b-input-group class="w-100 float-left">
                                <b-form-input type="number" step="0.01" v-model="item.insulation_cut.length" placeholder="Length" required></b-form-input>
                                <b-form-select v-model="item.insulation_cut.length_unit" :selected="'ft'" :options="['ft','in']" required></b-form-select>
                            </b-input-group>
                        </div>
                    </b-col>
                    <b-col v-if="item.type.name === 'Accessories'">
                        <div v-if="item.category">
                            <b-select v-model="item.product_id" required>
                                <b-select-option value="">-- Choose --</b-select-option>
                                <b-select-option-group v-if="item.category" :label="item.category.name">
                                    <b-select-option
                                        v-for="(product) in item.category.products"
                                        :value="product.id"
                                        :key="'acc-product-'+product.id"
                                    >{{decodeHTMLEntities(product.name)}}</b-select-option>
                                </b-select-option-group>
                            </b-select>
                        </div>
                    </b-col>
                    <b-col v-if="item.type.name === 'Other'">
                        <b-form-input type="text" v-model="item.description" placeholder="Custom" required></b-form-input>
                    </b-col>
                </b-row>

                <b-form-group v-if="item.type.name === 'Blocks'" label-cols="12" label="Quantity" class="mb-0">
                    <template v-slot:label>
                        Quantity
                        <font-awesome-icon
                            class="mx-2 mt-1"
                            :icon="['far','question-circle']"
                            v-c-tooltip="'ICF is ordered in sets of 4.'"
                        ></font-awesome-icon>
                    </template>
                    <b-form-input type="number" v-model="item.quantity" required step="4" @blur="(e) => blockValueFilter(e, index, item)"></b-form-input>
                </b-form-group>
                <b-form-group v-else label-cols="12" label="Quantity" class="mb-0">
                    <b-form-input type="number" v-model="item.quantity" step="1" min="1" max="99999" required></b-form-input>
                </b-form-group>

                <b-form-group label-cols="12" label="Price" class="mb-0">
                    <b-input-group prepend="$" class="prepend-sm">
                        <b-form-input type="number" v-model="item.price" step="0.01" required></b-form-input>
                    </b-input-group>
                </b-form-group>

                <b-form-group label-cols="12" label="Tax Percent(%)" class="mb-0">
                    <b-input-group append="%" class="append-sm">
                        <b-form-input type="number" v-model="item.tax_percent" step="1" min="0" max="100" required></b-form-input>
                    </b-input-group>
                </b-form-group>
                
                <div class="clearfix"><b-button variant="sf" squared class="mt-2 float-right"><font-awesome-icon :icon="['fal','trash']" @click="deleteRow(index)"></font-awesome-icon></b-button></div>

                <hr style="border-top: 2px solid rgba(0, 0, 0, 0.6);" />
            </div>
        </div>

        <div class="clearfix mb-lg-3" v-if="section === 'Shipping'">
            <div v-if="otherType && !items.length" class="float-right w-xs-100">
                <div class="d-block d-sm-inline-block" :key="otherType.id">
                    <div class="d-block d-sm-inline-block" >
                        <c-button @click="addTypeRow(otherType)" class="btn-sf btn-square ml-sm-2 mt-1 mt-sm-0 w-xs-100 w-sm-auto" size="sm">
                            <i class="fal fa-plus"></i> Shipping Cost
                        </c-button>
                    </div>
                </div>
            </div>
        </div>
        <div class="clearfix mb-lg-3" v-else>
            <div class="float-right w-xs-100">
                <div v-for="(type) in product_types" class="d-block d-sm-inline-block" :key="type.id">
                    <div v-if="hasTypeAccess(type)" class="d-block d-sm-inline-block" >
                        <c-button v-if="type.name !== 'Accessories'" @click="addTypeRow(type)" class="btn-sf btn-square ml-sm-2 mt-1 mt-sm-0 w-xs-100 w-sm-auto" size="sm">
                            <i class="fal fa-plus"></i> {{ (type.name === 'Other' ? 'Custom' : type.name) }}
                        </c-button>
                        <div v-if="type.name === 'Accessories'" class="d-block d-sm-inline-block">
                            <div v-for="(category) in type.product_categories" class="d-block d-sm-inline-block" :key="category.id">
                                <c-button v-if="!['None', 'Raw Product', 'Apparel', 'Shop Supplies', '2nd ICF', 'Marketing Assets'].includes(category.name)" @click="addCategoryRow(type, category)" class="btn-sf btn-square ml-sm-2 mt-1 mt-sm-0 w-xs-100 w-sm-auto" size="sm">
                                    <i class="fal fa-plus"></i> {{category.name}}
                                </c-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <c-data-table :fields="fields" :items="items" class="d-none d-lg-block">
            <template #actions="{item}">
                <td width="50">
                    <c-button @click="deleteRow(item.$uid)" class="btn-sf btn-square" size="sm"><i class="fal fa-trash"></i></c-button>
                </td>
            </template>
            <!-- <template #section="{item}">
                <td>
                    <b-select required :options="sections" v-model="item.section"></b-select>
                </td>
            </template> -->
            <template #previews="{item}">
                <td width="150">
                    <document-preview
                        v-if="item.product_id && getProductImage(item.product_id)"
                        :document="getProductImage(item.product_id)"
                        class="d-inline-block float-left mr-3"
                        :width="100"
                    ></document-preview>
                    <span v-else>N/A</span>
                </td>
            </template>
            <template #products="{item}">
                <td>
                    <div v-if="item.type.name === 'Blocks'">
                        <div v-if="item.type.product_categories">
                            <b-select v-model="item.product_id" required>
                                <b-select-option value="">-- Choose --</b-select-option>
                                <b-select-option-group 
                                    v-for="(category) in item.type.product_categories" 
                                    :label="category.name"
                                    :key="'block-product-category-'+category.id"
                                >
                                    <b-select-option
                                            v-for="(product) in category.products"
                                            :key="'block-product-'+product.id"
                                            :value="product.id"
                                    >{{decodeHTMLEntities(product.name)}}</b-select-option>
                                </b-select-option-group>
                            </b-select>
                        </div>
                    </div>
                    <div v-if="item.type.name === 'Insulation'">
                        <div v-if="item.type.product_classifications" class="clearfix">
                            <b-select v-model="item.product_id" class="w-100 float-left" required>
                                <b-select-option value="">-- Choose --</b-select-option>
                                <b-select-option-group 
                                    v-for="(classification) in item.type.product_classifications" 
                                    :label="classification.name"
                                    :key="'insulation-classification-'+classification.id"
                                >
                                    <b-select-option
                                        v-for="(product) in classification.products"
                                        :value="product.id"
                                        :key="'insulation-product-'+product.id"
                                    >{{decodeHTMLEntities(product.name)}}</b-select-option>
                                </b-select-option-group>
                            </b-select>
                            <b-input-group class="w-100 float-left">
                                <b-form-input type="number" step="0.01" v-model="item.insulation_cut.thickness" placeholder="Thickness" required></b-form-input>
                                <b-form-select v-model="item.insulation_cut.thickness_unit" :selected="'in'" :options="['in']" required></b-form-select>
                            </b-input-group>
                            <b-input-group class="w-100 float-left">
                                <b-form-input type="number" step="0.01" v-model="item.insulation_cut.width" placeholder="Width" required></b-form-input>
                                <b-form-select v-model="item.insulation_cut.width_unit" :selected="'ft'" :options="['ft','in']" required></b-form-select>
                            </b-input-group>
                            <b-input-group class="w-100 float-left">
                                <b-form-input type="number" step="0.01" v-model="item.insulation_cut.length" placeholder="Length" required></b-form-input>
                                <b-form-select v-model="item.insulation_cut.length_unit" :selected="'ft'" :options="['ft','in']" required></b-form-select>
                            </b-input-group>
                        </div>
                    </div>
                    <div v-if="item.type.name === 'Accessories'">
                        <div v-if="item.category">
                            <b-select v-model="item.product_id" required>
                                <b-select-option value="">-- Choose --</b-select-option>
                                <b-select-option-group v-if="item.category" :label="item.category.name">
                                    <b-select-option
                                        v-for="(product) in item.category.products"
                                        :value="product.id"
                                        :key="'acc-product-'+product.id"
                                    >{{decodeHTMLEntities(product.name)}}</b-select-option>
                                </b-select-option-group>
                            </b-select>
                        </div>
                    </div>
                    <div v-if="item.type.name === 'Other'">
                        <b-form-input type="text" v-model="item.description" :placeholder="section==='Shipping'?'Shipping Location':'Custom'" required></b-form-input>
                    </div>
                </td>
            </template>
            <template #quantity="{item, index}">
                <td width="145">
                    <div v-if="item.type.name === 'Blocks'">
                        <b-form-group>
                            <b-form-input type="number" v-model="item.quantity" required step="4" class="w-75 d-inline-block" @blur="(e) => blockValueFilter(e, index, item)"></b-form-input>
                            <font-awesome-icon
                                    class="mx-2 mt-1"
                                    :icon="['far','question-circle']"
                                    v-c-tooltip="{content: 'ICF is ordered in sets of 4.', placement: 'left'}"
                            ></font-awesome-icon>
                        </b-form-group>
                    </div>
                    <b-form-input v-else type="number" v-model="item.quantity" step="1" min="1" max="99999" required></b-form-input>
                </td>
            </template>
            <template #price="{item}">
                <td width="165">
                    <b-input-group prepend="$" class="prepend-sm">
                        <b-form-input type="number" v-model="item.price" step="0.01" required></b-form-input>
                    </b-input-group>
                </td>
            </template>
            <template #tax_percent="{item}">
                <td width="145">
                    <b-input-group append="%" class="append-sm">
                        <b-form-input type="number" v-model="item.tax_percent" step="1" min="0" max="100" required></b-form-input>
                    </b-input-group>
                </td>
            </template>
            <template #specs="{item}">
                <td width="150">
                    <document-preview
                            v-if="item.product_id && getProductSpec(item.product_id)"
                            :document="getProductSpec(item.product_id)"
                            class="d-inline-block float-left mr-3"
                            :width="100"
                    ></document-preview>
                    <span v-else>N/A</span>
                </td>
            </template>
        </c-data-table>
    </div>
</template>

<script>
  import Product from "@/models/Product";
import DocumentPreview from "@/components/documents/DocumentPreview";

  export default {
      name: 'EstimateCustomerItemForm',
      components: {DocumentPreview},
      props: ['section', 'customer', 'product_types', 'products', 'existing_items'],
      data () {
        return {
          fields: [
          	{key: 'actions', label: 'Actions'},
          	// {key: 'section', label: 'Section'},
            {key: 'previews', label: 'Preview(s)'},
            {key: 'products', label: 'Product(s)'},
            {key: 'quantity', label: 'Qty'},
            {key: 'price', label: 'Price'},
            {key: 'tax_percent', label: 'Tax(%)', },
            {key: 'specs', label: 'Spec(s)'},
          ],
          items: []
        }
      },
      computed: {
          otherType: function() {
              console.log(this.product_types);
              return this.product_types && this.product_types.length ? this.product_types.find(i=>i.name==='Other') : [];
          }
      },
      methods: {
        populateItems() {
            this.existing_items.forEach(i => {
                this.items.push(i);
            });
        },
        getProductImage(product_id) {
          let product = Product.query().with(['images']).whereId(product_id).first();
          if(product && product.getPrimaryImage()) {
            return product.getPrimaryImage();
          }
          return null;
        },
        getProductSpec(product_id) {
          let product = Product.query().with(['specifications']).whereId(product_id).first();
          if(product && product.getPrimarySpecification()) {
            return product.getPrimarySpecification();
          }
          return null;
        },
        addTypeRow(type) {
          this.newRow(type);
        },
        addCategoryRow(type, category) {
          this.newRow(type, category);
        },
        newRow(type, category, product, item) {
          this.items.push({
            $uid: this.uniqid(),
            id: item && item.id ? item.id : null,
            type: type,
            category: category,
            product_id: product ? product.id : null,
            insulation_cut: {
              id: (item && item.insulation_cut && item.insulation_cut.id ? item.insulation_cut.id : null),
              thickness: (item && item.insulation_cut && item.insulation_cut.thickness ? item.insulation_cut.thickness : null),
              thickness_unit: (item && item.insulation_cut && item.insulation_cut.thickness_unit ? item.insulation_cut.thickness_unit : (type && type.name === 'Insulation' ? 'in' : null)),
              width: (item && item.insulation_cut && item.insulation_cut.width ? item.insulation_cut.width : null),
              width_unit: (item && item.insulation_cut && item.insulation_cut.width_unit ? item.insulation_cut.width_unit : (type && type.name === 'Insulation' ? 'ft' : null)),
              length: (item && item.insulation_cut && item.insulation_cut.length ? item.insulation_cut.length : null),
              length_unit: (item && item.insulation_cut && item.insulation_cut.length_unit ? item.insulation_cut.length_unit : (type && type.name === 'Insulation' ? 'ft' : null)),
            },
            section: item && item.section ? item.section : this.section,
            quantity: item && item.quantity ? item.quantity : (this.section === 'Shipping' ? 1 : null),
            price: item && item.price ? item.price : null,
            tax_percent: item && item.tax_percent ? item.tax_percent : 5,
            description: item && item.description ? item.description : null
          });
        },
        uniqid(a = "", b = false) {
            const c = Date.now()/1000;
            let d = c.toString(16).split(".").join("");
            while(d.length < 14) d += "0";
            let e = "";
            if(b){
                e = ".";
                e += Math.round(Math.random()*100000000);
            }
            return a + d + e;
        },
        deleteRow(uid) {
          let index = this.items.findIndex(i => i.$uid === uid);
          if(index === -1) {
              return false;
          }
          this.items.splice(index, 1);
        },
        decodeHTMLEntities(text) {
          let textArea = document.createElement('textarea');
          textArea.innerHTML = text;
          return textArea.value;
        },
        blockValueFilter(e, index, item) {
          item.quantity = Math.ceil(Math.abs(e.target.value) / 4) * 4;
          this.items.splice(index, 1, item);
        },
        hasTypeAccess(type) {
          let access = this.customer ? this.customer.product_type_access : [];
          return access.includes(type.name);
        }
      },
      watch: {
          items: {
            handler: function() {
                this.$emit('update', this.items, this.section);
            },
            immediate: false,
            deep: true
          }
      },
      mounted() {
        if(this.section === 'Shipping') {
            this.fields = [
                {key: 'products', label: 'Shipping Location'},
                {key: 'quantity', label: 'Qty'},
                {key: 'price', label: 'Price'},
                {key: 'tax_percent', label: 'Tax(%)', }
            ];
        }
        this.populateItems();
      }
	}
</script>
<style>
.custom-select {
    font-size: 0.85rem;
}
.prepend-sm .input-group-text, .append-sm .input-group-text {
    font-size: 0.85rem;
}
</style>
